export type GetByIdType = (id: string) => ContentfulModel;

export abstract class ContentfulModel {
    private id: string;
    private type: string;

    constructor(object: any, private getByIdCallback: GetByIdType, fromJson = false) {
        this.type = this.getType();

        if (Object.keys(object).length === 0) {
            return;
        }

        if (fromJson) {
            Object.keys(object).forEach(key => this[key] = object[key]);
        } else {
            this.id = object.id;
            try {
                this.parseContentfulData(object);
            } catch (e) {
                console.error('Unable to parse ' + this.getType() + ' with data ' + JSON.stringify(object) + ' : ' + e.message);
            }
        }
    }

    getId(): string {
        return this.id;
    }

    getById(id: string): ContentfulModel {
        return this.getByIdCallback(id);
    }

    abstract getType(): string;

    abstract parseContentfulData(object: any): void;
};
